import { usePageMeta } from "@/hooks/usePageMeta";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import QuickEntries from "@/pages/home/components/QuickEntries";
import FeaturedSection from "@/pages/home/components/FeaturedSection";
import TopicsSection from "@/pages/home/components/TopicsSection";
import SiteIntro from "@/pages/home/components/SiteIntro";

const TITLE = "欧美精品在线观看-精选欧美电影电视剧推荐";
const DESCRIPTION =
  "欧美精品在线观看网站提供丰富的欧美电影和电视剧资源，涵盖最新和经典作品，满足用户在线观看欧美影视的多样需求。";

export default function Home() {
  usePageMeta(TITLE, DESCRIPTION, "/");

  return (
    <div className="w-full pb-6">
      <HeroCarousel />
      <QuickEntries />
      <FeaturedSection />
      <TopicsSection />
      <SiteIntro />
    </div>
  );
}